import { QuestionText } from '@absolutelabs/react-component-library';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFont from '../../../../../components/hooks/useFont';
import {
  selectCurrPage,
  selectFieldBackgroundColor,
  selectFieldBorderColor,
  selectFieldLightBorders,
  selectFieldPlaceholderColor,
  selectFieldSettings,
  selectFieldTextColor,
  selectFormTextColor,
  selectPreviewMode,
} from '../../../../../store/reducers/forms';

const QuestionTextField = ({ field }) => {
  const currPage = useSelector(selectCurrPage);
  const fieldSettings = useSelector(selectFieldSettings);
  const globalTextColor = useSelector(selectFormTextColor);
  const [fieldConfig, setFieldConfig] = useState({});
  const { font } = useFont('input');
  const fieldBackgroundColor = useSelector(selectFieldBackgroundColor);
  const placeholderColor = useSelector(selectFieldPlaceholderColor);
  const borderColor = useSelector(selectFieldBorderColor);
  const lightBorders = useSelector(selectFieldLightBorders);
  const previewMode = useSelector(selectPreviewMode);
  const fieldTextColor = useSelector(selectFieldTextColor);

  useEffect(() => {
    const currPageSettings = fieldSettings.find((o) => o.pageName === currPage);
    const config = currPageSettings?.fields?.find(
      (x) => x.field_id === field?.id
    );
    if (config) {
      setFieldConfig(config);
    }
  }, [fieldSettings, currPage, field?.id]);

  return (
    <QuestionText
      label={fieldConfig.label}
      placeholder={previewMode ? 'Lorem ipsum' : fieldConfig.placeholder || ''}
      subLabel={fieldConfig.subLabel}
      required={fieldConfig.required}
      multiline={fieldConfig.multiline}
      textColor={globalTextColor}
      font={font}
      backgroundColor={fieldBackgroundColor}
      placeholderColor={previewMode ? fieldTextColor : placeholderColor}
      borderColor={borderColor}
      lightBorders={lightBorders}
    />
  );
};

export default QuestionTextField;
